import React from 'react';
import SkeletonTable, {SkeletonTableColumnsType} from "../../Common/SkeletonTable";
import {ChangeInstanceMiniColumns} from "../../Common/Columns";
import {Card, Table, Typography, Tooltip} from "antd";
import {QuestionCircleOutlined} from '@ant-design/icons';

const { Title } = Typography;


const ChangeInstancesValidators = ({change_instances}: { change_instances: Record<string, any>[] }) => {
    change_instances && change_instances.forEach (ci => {
        if (ci["id"] == null)
            ci["id"] = "(new)"
        else
            ci["id"] += " (existing)"
    });
    return (
        <>
            <Card style={{width: '100%', margin: "10px"}} title={
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Title level={5} style={{ margin: 0, textAlign: "left" }}>Proposed Change Instances:</Title>
                    <Tooltip title="The following change instances will be generated if the you submit the declaration.">
                        <QuestionCircleOutlined style={{marginLeft: "5px"}}/>
                    </Tooltip>
                </div>
            }>
                <SkeletonTable columns={ChangeInstanceMiniColumns as SkeletonTableColumnsType[]}>
                    <Table
                        rowKey="service_item"
                        columns={ChangeInstanceMiniColumns}
                        dataSource={change_instances}
                        pagination={false}
                    />
                </SkeletonTable>
            </Card>
        </>
    )
}

export default ChangeInstancesValidators;
